module.exports = __webpack_public_path__ + "static/media/design-ux.288e7d6e.svg";